import React, { useEffect, useState } from "react";
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import Loader from '../../components/common/loader';
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { useForm } from "react-hook-form";
import AddButtonSection from '../../components/common/AddButtonSection';
import HighlightComponent from '../../components/common/highlightComponent';
import trash from "../../assets/images/trash.svg";
import { DevTool } from "@hookform/devtools";
import { convertToSearchField, fetchOptions } from "../../utils/utils";
import _ from "lodash";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import "../../assets/styles/addinvoice.scss";

export default function AddInvoice({ edit, ...props }) {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    setValue,
    clearErrors,
  } = useForm({ reValidateMode: "onChange" });

  const [visible, setVisible] = useState(false);
  const [serverLoading, setServerLoading] = useState(null);
  const [state, setState] = useState({});
  const [totalList, setTotalList] = useState([0]);
  const [paymentHistory, setPaymentHistory] = useState([0]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataExist, setDataExist] = useState(false);
  const [searchData, setSearchData] = useState("");
  const searchFeilds = ["patient_name", "patient_code"]
  const [navigator, setNavigator] = useState({
    searchCriteria: convertToSearchField(searchFeilds, "")
  })
  const lookupTypes = [{ type: "Payment_History", setter: setPaymentHistory }];

  const patient = (navigatorPayload, type) => {
    commonPostApi(API_ENDPOINTS.INVOICE_PATIENT_SEARCH, navigatorPayload).then(
      (data) => {
        setState((prev) =>
          type === "name"
            ? {
              ...prev,
              patientName: {
                ...(prev?.patientName || {}),
                items: data?.data?.data,
              },
              patient_common: {
                ...(prev?.patient_common || {}),
                items: data?.data?.data,
              },
            }
            : {
              ...prev,
              patientId: {
                ...(prev?.patientId || {}),
                items: data?.data?.data,
              },
              patient_common: {
                ...(prev?.patient_common || {}),
                items: data?.data?.data,
              },
            }
        );
      }
    );
  };

  const onsubmit = (data) => {
    if (
      !state?.selectedPatient?.patient_name ||
      !state?.selectedPatient?.patient_code
    ) {
      return;
    }
    const invoicedata = {
      patient_id: state?.selectedPatient?.patient_id,
      collectable_amount: totalList.map((item) => ({
        payment_category: watch(`category-${item}`),
        description: watch(`description-${item}`),
        amount: watch(`amount-${item}`),
      })),
    };
    if (dataExist)
      invoicedata.collectable_payment_description_id = props?.invoice_id;
    if (serverLoading) return;
    setServerLoading(true);
    commonPostApi(
      dataExist ? API_ENDPOINTS.EDIT_INVOICE : API_ENDPOINTS.ADD_INVOICE,
      invoicedata
    ).then((data) => {
      if (
        data?.data?.status === "created" ||
        data?.data?.status === "updated"
      ) {
        reset();
        props?.init?.();
        setDataExist(false);
        showToast(
          TOAST_TYPE.SUCCESS,
          dataExist
            ? FEATURE_MSG.INVOICE.UPDATED
            : FEATURE_MSG.INVOICE.ADDED
        );
        props?.setVisible?.(false);
        setServerLoading(false);
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setServerLoading(false);
      }
    });
  };

  const patientData = async (patientId) => {
    if (patientId) {
      try {
        const patientData = await commonPostApi(API_ENDPOINTS.SEARCH_PATIENT_DETAILS, {
          patient_id: patientId,
        });
        if (patientData?.data?.patient) {
          setState((prev) => ({
            ...prev,
            selectedPatient: patientData?.data?.patient,
          }));
        } else {
          console.warn("No patient data found for ID:", patientId);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
        showToast("error", "Failed to load patient data");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const init = async () => {
    try {
      const data = await commonPostApi(API_ENDPOINTS.GET_INVOICE_BY_ID, {
        collectable_payment_description_id: props?.invoice_id,
      });

      if (data?.data?.invoice && Object.keys(data?.data?.invoice).length > 0) {
        setDataExist(true);
        const { payment_categories, ...rest } = data?.data?.invoice;
        setValue("total_invoice_amount", rest?.total_collectable_amount);
        setValue("total_paid_amount", rest?.total_paid_amount);
        setValue("total_balance_amount", rest?.total_balance_amount);

        if (payment_categories?.length > 0) {
          setTotalList([...Array(payment_categories.length).keys()]);
          [...Array(payment_categories.length).keys()]?.map?.((item) => {
            setValue(
              `category-${item}`,
              payment_categories[item]?.payment_category
            );
            setValue(
              `description-${item}`,
              payment_categories[item]?.description
            );
            setValue(
              `amount-${item}`,
              payment_categories[item]?.collectable_amount
            );
          });
        }

        await patientData(data?.data?.invoice?.patient_id);
      } else {
        console.warn("No invoice data found for ID:", props?.invoice_id);
        showToast("error", "Invoice not found");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching invoice data:", error);
      showToast("error", "Failed to load invoice data");
      setLoading(false);
    }
  };

  const onSubmitClick = () => {
    if (
      !state?.selectedPatient?.patient_name ||
      !state?.selectedPatient?.patient_code
    ) {
      setError(true);
    } else {
      setError(false);
    }
    handleSubmit(onsubmit)();
  };

  const buttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-2 btn-end",
      onClick: onSubmitClick,
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-2 btn-end",
      onClick: () => {
        props?.setVisible?.(false);
      },
    },
  ];

  const patientCommonSearch = ({ query }) => {
    setNavigator(() => ({
      searchCriteria: convertToSearchField(searchFeilds, query),
    }));
    setSearchData(query);
  };

  useEffect(() => {
    let handler;
    handler = setTimeout(() => {
      if (searchData && searchData.length > 0) {
        patient({ navigator });
      }
    }, 600);
    return () => clearTimeout(handler);
  }, [searchData]);


  useEffect(() => {
    if (props?.patientId) {
      setLoading(true);
      patientData(props?.patientId);
    }
  }, [props?.patientId]);

  useEffect(() => {
    if (edit) {
      setLoading(true);
      init();
    }
  }, [edit]);
  useEffect(() => {
    setValue("invoice_date", new Date());
    lookupTypes.forEach(({ type, setter }) => {
      fetchOptions(type, setter);
    });
  }, []);

  useEffect(() => {
    setVisible(props?.visible);
  }, [props?.visible]);

  useEffect(
    () => {
      let amount = 0;
      setValue("total_paid_amount", amount);
      totalList.forEach((item) => {
        if (typeof watch(`amount-${item}`) == "number")
          amount += watch(`amount-${item}`);
      });
      setValue("total_invoice_amount", amount);
      setValue(
        "total_balance_amount",
        watch("total_paid_amount")
          ? amount - watch("total_paid_amount")
          : amount
      );
    },
    totalList.map((item) => watch(`amount-${item}`))
  );
  return (
    <React.Fragment>
      <PrimarySideBar
        visible={visible}
        onHide={() => props?.setVisible?.(false)}
        header={
          <div className="sideBar-header">
            {edit ? "Edit Invoice" : "Add Invoice"}
          </div>
        }
        className={"w-40rem"}
      >
        {loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div>
              {edit || props?.patientId ? (
                ""
              ) : (
                <div className="">
                  <InputPrimaryComponents
                    inter
                    type="autocomplete"
                    label="Patient Search"
                    field="concatData"
                    placeholder="Type to search"
                    searchIcon
                    disabled={props?.patientId}
                    items={state?.patient_common?.items}
                    value={[state?.patient_common?.value || ""]}
                    error={
                      !state?.selectedPatient?.patient_common &&
                      error &&
                      "patient is required"
                    }
                    search={patientCommonSearch}
                    onChange={(e) => {
                      if (typeof e == "object") {
                        setError(false);
                        setState((prev) => ({
                          ...prev,
                          patient_common: {
                            ...prev?.patient_common,
                            value: e?.concatData,
                          },
                          selectedPatient: e,
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          patient_common: {
                            ...prev?.patient_common,
                            value: e,
                          },
                        }));
                      }
                    }}
                  />
                </div>
              )}
            </div>
            <div className="invoice-fist-sec md:max-sm:mr-2">
              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  inter
                  type="autocomplete"
                  label="Patient Name"
                  field="patient_name"
                  placeholder="Type here"
                  disabled={props?.patientId || true}
                  items={state?.patientName?.items}
                  value={[state?.selectedPatient?.patient_name || ""]}
                />
              </div>
              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  inter
                  type="autocomplete"
                  label="Patient ID"
                  field="patient_code"
                  placeholder="Type here"
                  disabled={props?.patientId || true}
                  items={state?.patientId?.items || []}
                  value={[state?.selectedPatient?.patient_code || ""]}
                />
              </div>
            </div>

            <div className="invoice-fist-sec">
              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  inter
                  type="calendar"
                  label="Invoice Date"
                  field="invoice_date"
                  placeholder="Select"
                  name="invoice_date"
                  disabled
                  control={control}
                />
              </div>

              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  type="currency"
                  label="Total Invoice Amount"
                  name="total_invoice_amount"
                  placeholder="Enter value"
                  disabled
                  control={control}
                />
              </div>
            </div>
            <div className="invoice-fist-sec">
              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  type="currency"
                  label="Total Paid Amount"
                  name="total_paid_amount"
                  placeholder="Enter value"
                  disabled
                  control={control}
                />
              </div>
              <div className="col-6 invoice-input">
                <InputPrimaryComponents
                  type="currency"
                  label="Total Balance Amount"
                  name="total_balance_amount"
                  disabled
                  placeholder="Enter value"
                  control={control}
                />
              </div>
            </div>
            <div>
              <HighlightComponent>
                <div className="p-3">
                  <div className="primary-standard-heading">
                    Category Amounts
                  </div>

                  <div>
                    {totalList.map((item, ind) => (
                      <div className="pt-3 invoice-fist-sec" key={item}>
                        <div className="col-4 invoice-Category-input">
                          <InputPrimaryComponents
                            type="dropdown"
                            label="Category"
                            errors={errors}
                            required
                            rules={{ required: "Category is required" }}
                            name={`category-${item}`}
                            control={control}
                            placeholder="Select"
                            options={paymentHistory || []}
                            inputParentClass={"div_pb-0"}
                          />
                        </div>
                        <div className="col-4 invoice-Category-input">
                          <InputPrimaryComponents
                            type="text"
                            label="Description"
                            placeholder="Type here"
                            name={`description-${item}`}
                            control={control}
                            inputParentClass={"div_pb-0"}
                          />
                        </div>
                        <div className="col-4 invoice-Category-input">
                          <InputPrimaryComponents
                            type="currency"
                            label="Amount"
                            required
                            rules={{ required: "Amount is required" }}
                            name={`amount-${item}`}
                            onChange={(e) => {
                              setError(false);
                              if (e) clearErrors(`amount-${item}`);
                            }}
                            errors={errors}
                            control={control}
                            placeholder="Enter"
                            inputParentClass={"div_pb-0"}
                          />
                        </div>
                        <span className="border border-b-2">
                          {totalList?.length === 1 ? (
                            ""
                          ) : (
                            <div className="mt-3 flex justify-content-center w-full">
                              <img
                                src={trash}
                                onClick={() => {
                                  setValue(`category-${item}`, "");
                                  setValue(`description-${item}`, "");
                                  setValue(`amount-${item}`, "");

                                  setTotalList((prev) =>
                                    prev?.filter((i) => i !== item)
                                  );
                                }}
                                alt="trash"
                              />
                            </div>
                          )}
                        </span>
                        <div
                          key={ind}
                          className={` ${ind !== totalList.length - 1
                            ? "card-line-divider"
                            : ""
                            }`}
                        ></div>
                      </div>
                    ))}
                  </div>
                  <div className="pt-3 w-full">
                    <AddButtonSection
                      buttons={[
                        {
                          type: "primaryButton",
                          icon: "pi pi-plus",
                          label: "Add category",
                          class: "col-4 add-Category-btn",
                          onClick: () => {
                            setTotalList((prev) => [...prev, _.last(prev) + 1]);
                          },
                        },
                      ]}
                    />
                  </div>
                </div>
              </HighlightComponent>
            </div>

            <div className="pt-3">
              <AddButtonSection disabled={serverLoading} buttons={buttons} />
            </div>
          </React.Fragment>
        )}
      </PrimarySideBar>
      <DevTool control={control} />
    </React.Fragment>
  );
}
